module.exports = __webpack_public_path__ + "media/game_top.d94ade11.mp3";